import script from "./TraitShopPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopPanel.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopPanel.vue?vue&type=style&index=0&id=4734ecc4&lang=scss"

const __exports__ = script;

export default __exports__